module.exports = __webpack_public_path__ + "static/media/Qr.f63b65fe.png";